import { connect } from 'react-redux';
import { formValueSelector, change } from 'redux-form';
import RegisterForm from './RegisterForm';
import { register, forgotPassword, validateUniqueEmail } from './RegisterActions';
import getPasswordStrength from '../form/PasswordStrength';
import switchTab from '../app/AppActions';

const selector = formValueSelector('register');

function mapStateToProps(state, ownProps) {
  return {
    initialValues: {
      firstName: ownProps.customer && ownProps.customer.firstName,
      lastName: ownProps.customer && ownProps.customer.lastName,
      email: ownProps.customer && ownProps.customer.email,
      accountInvitationGuid: ownProps.accountInvitationGuid !== undefined ?
        ownProps.accountInvitationGuid : undefined,
    },
    isSubmitting: state.register.isSubmitting,
    passwordStrength: getPasswordStrength(selector(state, 'password')),
    updateIsUniqueEmail: ownProps.updateIsUniqueEmail,
    isUniqueEmail: ownProps.isUniqueEmail,
    serverMessage: state.register.serverMessage,
    hasSuccessfullyCreatedAccount: state.register.hasSuccessfullyCreatedAccount,
    showAlreadyHaveAccount: ownProps.showAlreadyHaveAccount,
    finishCreatingAccount: ownProps.finishCreatingAccount,
    showSignIn: ownProps.showSignIn,
    showAccountBenefitsText: ownProps.showAccountBenefitsText,
  };
}

function mapDispatchToProps(dispatch, ownProps) {
  return {
    onSubmit: values => dispatch(register(values, ownProps.onRegistrationSuccess)),
    onForgotPasswordClicked: () => dispatch(forgotPassword()),
    onEmailBlurred: () => dispatch(validateUniqueEmail()),
    prefillLoginEmail: email => dispatch(change('login', 'login-email', email)),
    signIn: () => dispatch(switchTab('signIn')),
  };
}

const RegisterContainer = connect(mapStateToProps, mapDispatchToProps)(RegisterForm);
export default RegisterContainer;
